module.exports = __webpack_public_path__ + "static/media/fastdoc.d2386d9e.svg";